/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { makeAsyncAction } from 'ui-lottery/src/utils/async_utils';
import * as api from '../api';
import * as types from '../constants/actions';

export const fetchPassTypes = makeAsyncAction(
    types.FETCH_PASS_TYPES,
    (facilityId) => () => api.getPassTypes(facilityId),
    'pass_types'
);

export const fetchPassType = makeAsyncAction(
    types.FETCH_PASS_TYPE,
    (passTypeId) => () => api.getPassType(passTypeId),
    'pass_type'
);
